module.exports = __webpack_public_path__ + "img/Sharp Edge.4ddad73d.png";